import { Stack } from '@mui/material';

import AgendaPage from 'pages/Cockpit/components/Agenda/AgendaPage';
import { EventCarouselProps } from 'pages/Cockpit/components/Agenda/types/agendaTypes';
import ImageCarousel from 'pages/Cockpit/components/ImagesCarousel';

const MobileCockpit = ({ events }: EventCarouselProps) => {
  return (
    <Stack sx={{ width: '100%', height: '100%' }} direction="column" gap={4}>
      <ImageCarousel />
      <AgendaPage />
    </Stack>
  );
};

export default MobileCockpit;
